export default function HabitacionesPage() {
  const rooms = [
    { img: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=85', type: 'Habitación', name: 'Classique', size: '35 m²', features: 'King bed · City view · Desayuno incluido', price: '290' },
    { img: 'https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=800&q=85', type: 'Suite', name: 'Dorée', size: '68 m²', features: 'Salón privado · Panoramic view · Butler', price: '590' },
    { img: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&q=85', type: 'Suite', name: 'Impériale', size: '120 m²', features: 'Terrasse privée · 120m² · Butler 24h', price: '890' }
  ];

  return (
    <div data-testid="habitaciones-page" style={{ background: '#FAFAF8' }}>

      {/* Hero */}
      <section style={{ background: '#050505', padding: 'clamp(6rem,12vw,10rem) clamp(2rem,8vw,8rem) clamp(3rem,6vw,5rem)', textAlign: 'center' }} data-testid="habitaciones-hero">
        <p style={{ fontFamily: "'Jost',sans-serif", fontSize: '0.7rem', letterSpacing: '0.35em', textTransform: 'uppercase', color: '#B8892A', marginBottom: '1rem' }}>Accommodations</p>
        <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 'clamp(3rem,6vw,5rem)', fontWeight: 300, color: '#FAFAF8' }}>Our Sanctuaries</h1>
      </section>

      {/* Cards */}
      <section style={{ padding: 'clamp(4rem,8vw,6rem) clamp(2rem,8vw,8rem)' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '2px' }}>
          {rooms.map((room, i) => (
            <div key={i} style={{ background: '#FFFFFF', overflow: 'hidden', cursor: 'pointer' }}
              onMouseEnter={e => e.currentTarget.querySelector('img').style.transform = 'scale(1.05)'}
              onMouseLeave={e => e.currentTarget.querySelector('img').style.transform = 'scale(1)'}
              data-testid={`room-card-${i}`}>
              <div style={{ overflow: 'hidden' }}>
                <img src={room.img} alt={room.name} style={{ width: '100%', height: '300px', objectFit: 'cover', display: 'block', transition: 'transform 0.8s cubic-bezier(0.25,0.46,0.45,0.94)' }} />
              </div>
              <div style={{ padding: '2rem' }}>
                <p style={{ fontFamily: "'Jost',sans-serif", fontSize: '0.65rem', letterSpacing: '0.25em', textTransform: 'uppercase', color: '#B8892A', marginBottom: '0.5rem' }}>{room.type} · {room.size}</p>
                <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: '2rem', fontWeight: 300, color: '#1A1A1A', marginBottom: '0.75rem' }}>{room.name}</h2>
                <p style={{ fontFamily: "'Jost',sans-serif", fontSize: '0.875rem', fontWeight: 300, color: '#6B6460', lineHeight: 1.7, marginBottom: '1.5rem' }}>{room.features}</p>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: '1.5rem', color: '#B8892A' }}>desde {room.price}€<span style={{ fontSize: '0.9rem', color: 'rgba(184,137,42,0.6)' }}>/noche</span></span>
                  <a href="/reservar" style={{ fontFamily: "'Jost',sans-serif", fontSize: '0.7rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: '#FFFFFF', background: '#B8892A', padding: '0.7rem 1.5rem', textDecoration: 'none' }} data-testid={`room-reserve-${i}`}>Reservar</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
}
